import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useFetch } from "hooks";
import { put } from "utils/api";
import { Spinner } from "components/ui";
import { errorMessage } from "actions/message";
import { getApiErrorMessageCustomPathEnd } from "utils/misc";
import { useDispatch, useSelector } from "react-redux";
import { selectors } from "reducers";
import { fetchSasCompanyAdministrators } from "actions/enum";

const BulkFirstTimeRegistrationAssignModal = ({
  patientIds,
  onUpdateSuccess,
  setSubmitEnabled
}) => {
  const dispatch = useDispatch();
  const [selectedAdmin, setSelectedAdmin] = useState({
    text: "Select Coach",
    value: ""
  });

  const availableAdmins = useSelector(selectors.getSasCompanyAdministrators);
  const adminsStatus = useSelector(selectors.getSasCompanyAdministratorsStatus);
  // An empty list is not "still loading"; the status says whether the list was requested.
  const isFetching = adminsStatus === "idle" || adminsStatus === "loading";
  const failedToLoad = adminsStatus === "error";

  // The match page opens this modal too, and it can be reached without visiting the dashboard
  // (new tab, refresh), so request the list here when nothing has loaded it yet or it failed.
  useEffect(() => {
    if (adminsStatus === "idle" || adminsStatus === "error")
      dispatch(fetchSasCompanyAdministrators());
    // Once per open: retrying on every "error" render would loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { fetchData: confirmAssign, isFetching: confirmingAssign } = useFetch({
    apiFn: () =>
      put("first-time-registration-dashboard/bulk-assign", {
        Records: patientIds,
        UserId: selectedAdmin.value
      }),
    defaultValue: [],
    onError: error => {
      dispatch(
        errorMessage(
          `Failed to assign registers: ${getApiErrorMessageCustomPathEnd(
            error,
            "message"
          )}`
        )
      );
    },
    onSuccess: () => onUpdateSuccess()
  });

  const handleSelectChange = event => {
    const value = event.target.value;
    const text = event.target.options[event.target.selectedIndex].text;
    setSelectedAdmin({ text: text, value: value });
  };


  useEffect(() => {
    if (typeof setSubmitEnabled == "function")
      setSubmitEnabled(isFetching || failedToLoad || selectedAdmin.value == "");
  }, [isFetching, failedToLoad, selectedAdmin]);

  return (
    <div style={{ padding: "1em" }}>
      <h4 style={{ color: "#87d59e" }}>Assign to</h4>
      <div>
        <hr style={{ marginBottom: 0 }} />
        {isFetching ? (
          <Spinner />
        ) : failedToLoad ? (
          <p>
            The list of users could not be loaded. Close this and open it again to retry.
          </p>
        ) : (
          <select
            value={selectedAdmin.value}
            onChange={e => handleSelectChange(e)}
          >
            <option value="">Select Coach</option>
            {availableAdmins.map(coach => (
              <option key={coach.value} value={coach.value}>
                {coach.text}
              </option>
            ))}
          </select>
        )}
      </div>
      <div>
        {confirmingAssign ? (
          <Spinner />
        ) : typeof setSubmitEnabled == "function" ? (
          <div
            id="submit-assign"
            onClick={confirmAssign}
            disabled={isFetching || failedToLoad || selectedAdmin.value == ""}
            type="button"
          />
        ) : (
          <button
            id="submit-assign"
            onClick={confirmAssign}
            disabled={isFetching || failedToLoad || selectedAdmin.value == ""}
            type="button"
          >
            Submit
          </button>
        )}
      </div>
    </div>
  );
};

BulkFirstTimeRegistrationAssignModal.propTypes = {
  patientIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onUpdateSuccess: PropTypes.func,
  setSubmitEnabled: PropTypes.func,
};

export default BulkFirstTimeRegistrationAssignModal;
